/**
 * Provides access to the pageViewLogDataId stored in the document's dataset.
 * Lazily reads it once and caches the value for future calls.
 * Returns an empty string if the dataset attribute is missing.
 */
export class PageViewLogDataId {
    private static pageViewLogDataId: string | undefined;

    public static get(): string {
        if (!PageViewLogDataId.pageViewLogDataId) {
            PageViewLogDataId.pageViewLogDataId =
                document.documentElement.dataset.pageViewLogDataId ?? "";
        }
        return PageViewLogDataId.pageViewLogDataId;
    }
}
